const REVENUE_ROLLOUT_KEYS = Object.freeze({
  billingLive: 'billing_live',
  proPaywallEnabled: 'pro_paywall_enabled',
  proPaywallMessageExperimentEnabled: 'pro_paywall_message_experiment_enabled',
  creatorPilotEnabled: 'creator_pilot_enabled',
  tribeMomentumEnabled: 'tribe_momentum_enabled',
  paidPacksEnabled: 'paid_packs_enabled',
});

const DEFAULT_REVENUE_ROLLOUT_CONFIG = Object.freeze(
  Object.values(REVENUE_ROLLOUT_KEYS).reduce((config, key) => ({
    ...config,
    [key]: false,
  }), {}),
);

const KEY_ALIASES = Object.freeze({
  [REVENUE_ROLLOUT_KEYS.billingLive]: ['billing_live', 'billingLive', 'BILLING_LIVE', 'REACT_APP_BILLING_LIVE'],
  [REVENUE_ROLLOUT_KEYS.proPaywallEnabled]: ['pro_paywall_enabled', 'proPaywallEnabled', 'PRO_PAYWALL_ENABLED', 'REACT_APP_PRO_PAYWALL_ENABLED'],
  [REVENUE_ROLLOUT_KEYS.proPaywallMessageExperimentEnabled]: ['pro_paywall_message_experiment_enabled', 'proPaywallMessageExperimentEnabled', 'PRO_PAYWALL_MESSAGE_EXPERIMENT_ENABLED', 'REACT_APP_PRO_PAYWALL_MESSAGE_EXPERIMENT_ENABLED'],
  [REVENUE_ROLLOUT_KEYS.creatorPilotEnabled]: ['creator_pilot_enabled', 'creatorPilotEnabled', 'CREATOR_PILOT_ENABLED', 'REACT_APP_CREATOR_PILOT_ENABLED'],
  [REVENUE_ROLLOUT_KEYS.tribeMomentumEnabled]: ['tribe_momentum_enabled', 'tribeMomentumEnabled', 'TRIBE_MOMENTUM_ENABLED', 'REACT_APP_TRIBE_MOMENTUM_ENABLED'],
  [REVENUE_ROLLOUT_KEYS.paidPacksEnabled]: ['paid_packs_enabled', 'paidPacksEnabled', 'PAID_PACKS_ENABLED', 'REACT_APP_PAID_PACKS_ENABLED'],
});

function isExplicitlyEnabled(value) {
  return value === true || value === 'true';
}

function resolveRevenueRolloutConfig(source = {}) {
  return Object.freeze(
    Object.entries(KEY_ALIASES).reduce((config, [canonicalKey, aliases]) => {
      const configuredAlias = aliases.find(
        (alias) => Object.prototype.hasOwnProperty.call(source || {}, alias),
      );
      const value = configuredAlias === undefined ? undefined : source[configuredAlias];
      return {
        ...config,
        [canonicalKey]: isExplicitlyEnabled(value),
      };
    }, { ...DEFAULT_REVENUE_ROLLOUT_CONFIG }),
  );
}

function isRevenueRolloutEnabled(key, source = {}) {
  if (!Object.values(REVENUE_ROLLOUT_KEYS).includes(key)) return false;
  return resolveRevenueRolloutConfig(source)[key] === true;
}

function canOfferProPurchase(source = {}) {
  const config = resolveRevenueRolloutConfig(source);
  return config.billing_live && config.pro_paywall_enabled;
}

function canRunProPaywallMessageExperiment(source = {}) {
  const config = resolveRevenueRolloutConfig(source);
  return config.billing_live
    && config.pro_paywall_enabled
    && config.pro_paywall_message_experiment_enabled;
}

function canOfferPaidPacks(source = {}) {
  const config = resolveRevenueRolloutConfig(source);
  return config.billing_live && config.paid_packs_enabled;
}

export {
  DEFAULT_REVENUE_ROLLOUT_CONFIG,
  REVENUE_ROLLOUT_KEYS,
  canOfferPaidPacks,
  canOfferProPurchase,
  canRunProPaywallMessageExperiment,
  isRevenueRolloutEnabled,
  resolveRevenueRolloutConfig,
};
